let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("890pK")]).then(() => parcelRequire('a2EQ7'));